import { h, ComponentChildren } from 'preact'

type Props = {
    providerName: string,
    children: ComponentChildren
}

const MethodBox = ({ providerName, children }: Props) =>
  <div class='method-box' provider-name={providerName}>
    {children}
  </div>

export default MethodBox
